/*
 * Copyright (C) 2017-present Connection Loops Pvt. Ltd., Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */


export default class AppURL {
  public static ROOT_PATH = "/";
  public static LOGIN_URL = "/auth/login";
  public static HOME_URL = "/home";
  public static MASTER_URL = "/master";
  public static FRANCHISE_URL = "/francise";
  public static ITEMS_MASTER_URL = "/items";
  public static PARTY_MASTER_URL = "/partymaster";
  public static USER_MANAGEMENT_URL = "/usermanagement";
  public static ROLES_MANAGEMENT_URL = "/rolesmanagement";
  public static CONTACT_MASTER_URL = "/contactmaster";
  public static REPORT_VIEWER = "/reportviewer";
}

export const BASE_URL = "https://hallmark.clps.co/CLHallmark/api";
export const FQDN = "clhallmark.connectionloops.com";
export const BLOB_PATH = "https://cloopscb.blob.core.windows.net/clhallmark/";
export const TEMP_STORAGE  = "https://hallmark.clps.co/temp_storage/";
export const ORG_ID = "VASAVI";

export class ApiUrls{
  public static LOGIN_URL = "/issue-jwt";
  public static USER_URL = "/login";
  public static DELETE_USER_URL = "/delete_user";
  public static BASE_ITEMS_URL = "/items";
  public static DELETE_ITEMS_URL = "/items/delete"
  public  static  FileUpload = "/file/upload"
  //Franchise Url
  public static BASE_FRANCHISE_URL = "/franchise"

  //Party Master Url
  public static BASE_PARTY_URL = "/party"
  public static DELETE_PARTY_URL = "/party/delete"
  //Party Master Url
  public static BASE_PARTY_BILL_URL = "/bills"
  public static GET_PARTY_BILL_URL = "/bills/get"
  public static DELETE_PARTY_BILL_URL = "/bills/delete"
  public static PARTY_BILL_NO_BILL_URL = "/bills/BillNo"
  public static BILL_UNPAID_URL = "/bills/unpaid"
  public static BILL_DELIVERY_URL = "/bills/delivered"

  //Role Master Url
  public static BASE_ROLE_URL = "/roles"
  public static BASE_MODULE_URL = "/modules"
  public static BASE_REPORT_VIEW = "/reports/pdf"
  public static BASE_REPORT_VIEW_EXCEL = "/reports/excel"
  public static BASE_REPORT_VIEW_DATA = "/reports/data"

  //Contact Master URL
  public static BILL_PAYMENTS = "/bills/payments"
  public static BILL_INVOICE = "/bills/invoice"
  public static BASE_CONTACT_PERSON_URL = "/contactperson"
  public static DELETE_CONTACT_PERSON = "/contactperson/delete"
}

export class PreferenceConstants{
  public static SELECTED_FRANCHISE = "SELECTED_FRANCHISE"
  public static USER_INFO = "USER_INFO"
  public static CPT = "CPT"
  public static ORG_ID = "ORG_ID"
}